var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoInverseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352.9 87.7",
    style: {
      enableBackground: "new 0 0 352.9 87.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.4,42.4c11.2-3.7,13.2-13.1,13.1-20.7C173.6,10.1,165.3,0,141,0L95.6,0c0,0,0,85,0,87.5 c2.5,0,45.3,0,45.3,0c24.5,0,33.5-12.6,33.5-25.2C174.4,47.1,160.4,42.4,160.4,42.4z M117.1,19h30.5h0.1l0.1,0c3.5,0.6,6,3.5,6,7 c0,3.5-2.7,6.8-6.2,7.3l-30.4,0.1L117.1,19z M146.3,67.1h-29.1V52.5h29.7h0.1l0.1,0c3.7,0.4,6.5,3.5,6.5,7.2 C153.6,63.7,150.2,67.1,146.3,67.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.1,0h76.8l0,19.1h-55.4l0.1,14.1h49.9v19.2h-49.9v15.3h55.4l0,20c0,0-74.2,0-76.8,0 C276.1,85.2,276.1,0,276.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.5,0.1H185v87.6c0,0,19.1,0,21.3,0c0-2.5,0-35.4,0-35.4s23.5,0,23.5,0c6.7,0.1,12,5.6,12,12.4v23l20.9,0 l0-28.3c0-13.1-12.6-17-12.6-17s12.9-3.9,12.9-19.3C262.9,4.1,246.6,0.1,231.5,0.1z M243.1,27.3c-0.4,2.9-3.3,6-6.9,6l-30,0v-14h30 c3.6,0,6.4,2.6,6.8,6.1V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.7,66.5c-0.3,0-29.1,0.6-39.1-0.4c-16-1.6-21.7-13.4-21.7-23.1c0-12.1,8.2-21,21-22.7 c6.1-0.8,39.3-0.4,39.6-0.4l0.7,0L82.3,0l-0.7,0L44.1,0.1c-4.2,0.3-11.1,0.7-18.2,3.6C19,6.8,13.1,11.6,8.6,17.6 C3,25.2,0,34.2,0,43.7c0,3,0.2,5.9,0.7,8.8c2.7,13.3,11.4,24.3,23.9,30.2c4.2,1.9,10.7,4.1,23.8,4.8c0,0,7.1,0.1,7.1,0.1 c0,0,26.2,0,26.2,0h0.7l0.1-21.1L81.7,66.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInverseWhite);
export default __webpack_public_path__ + "static/media/logo-inverse-white.3cb18fb96382a8b9632a26b85095da2a.svg";
export { ForwardRef as ReactComponent };